import "../../../../node_modules/roboto-fontface/css/roboto-condensed/roboto-condensed-fontface.css";
import Ribbon from '@/core/ribbon/ribbon.vue';
import Navbar from './core/navbar/navbar.vue';
import AlertDialog from '@/core/alert/component/AlertDialog.vue';

import '@/shared/config/dayjs';
import AccountService from '@/account/account.service';
import {RouterStore} from '@/shared/config/store/router.store';
import {getModule} from 'vuex-module-decorators';
import {Breadcrumb} from '@/core/router/interface/breadcrumb.interface';
import {
    ComponentInternalInstance,
    computed,
    ComputedRef,
    defineComponent,
    getCurrentInstance,
    inject,
    onMounted,
    ref,
    Ref,
    watch
} from "@vue/composition-api";
import {store} from "@/store";

export default defineComponent({
    name: "App",
    components: {
        ribbon: Ribbon,
        navbar: Navbar,
        AlertDialog,
    },
    setup() {
        const accountService: () => AccountService = inject("accountService");
        const routerStore: RouterStore = getModule(RouterStore);

        const instance: Ref<ComponentInternalInstance> = ref();
        const authenticated: ComputedRef<boolean> = computed(() => store.getters.authenticated);
        const inProduction: ComputedRef<boolean> = computed(() => store.getters.activeProfiles.indexOf('prod') > -1);
        const isHomepage: ComputedRef<boolean> = computed(() => {
            if (!instance.value) {
                return false;
            }
            const fullPath = instance.value.vnode.componentInstance.$router.currentRoute.fullPath;
            return fullPath === "/login" || (fullPath === "/" && !authenticated.value);
        })

        const breadcrumbs: ComputedRef<any[]> = computed(() => {
            const breadcrumbs: Breadcrumb[] = [{text: 'Home', href: '/'}, ...routerStore.breadcrumbs];
            if (!instance.value) {
                return [];
            }
            return breadcrumbs.map((b, index) => ({
                text: typeof b.text === 'string' ? b.text : instance.value.vnode.componentInstance.$t(b.text.i18nKey, b.text.parameters),
                to: b.href,
                disabled: index === breadcrumbs.length - 1,
                exact: true,
            }));
        });

        onMounted(() => {
            accountService().retrieveAccount();
            instance.value = getCurrentInstance();
        });

        watch(breadcrumbs, bc => {
            let title: string = bc
                .slice(1)
                .map(breadcrumb => breadcrumb.text)
                .join(' // ');
            if (!title) {
                title = "MoreCore Insights";
            }
            document.title = title;
        });

        return {
            authenticated,
            inProduction,
            isHomepage,
            breadcrumbs,
        };
    }
});
